// extracted by mini-css-extract-plugin
export default {"resumeFrame":"Resume_resumeFrame__LsLdo"};